import React, { useState } from "react";
import comit from "../../Images/mental-healthcomitment.png";
import ServiceSlider from "../../commanfile/ServiceSlider";
import PsynexaPost1 from "../../Images/mentalillnessimage2.png";
import PsynexaPost2 from "../../Images/mentalillnessimage4.jpg";
import Tretmentwork from "../../commanfile/Tretmentwork";
import Button from "../../commanfile/Button";
import { FaHandHoldingHeart } from "react-icons/fa6";
import Servicelist from "../../commanfile/Servicelist";

const Mentalillness = () => {
  const Symtams = [
    "Sadness or low mood lasting several weeks ",
    "Suicidal thoughts, self-harm, or behavior",
    "Excessive anger, hostility, or violence.",
    "Neglect of personal hygiene or routine tasks.",
    "Substance abuse or using drugs/alcohol to cope.",
    "Excessive fears, worries, or feelings of guilt.",
    "Problems coping with daily stress, responsibilities, or relationships.",
    "Extreme mood swings, ranging from high energy and euphoria (mania) to deep depression.",
    
  ];
  const symtams1 = [
     "loss of interest in activities.",
    "Detachment from reality, including delusions (false beliefs), paranoia, or hallucinations (seeing/hearing things others don’t).",
    "Major changes in eating habits or weight, such as sudden overeating or loss of appetite.",
    "Disrupted sleep patterns, such as insomnia or sleeping excessively.",
    "Withdrawal from friends, family, and usual activities",
    "Confused thinking or reduced ability to concentrate and remember",
   
    

  ];

  const Data = [
    {
      question: "What is mental illness?",
      answer: "Mental illness is defined as a health condition involving significant changes in emotion, thinking, or behavior, often associated with distress and/or problems functioning in social, work, or family activities."
    },
    {
      question: "How do I know if I or someone I love is struggling with a mental health condition?",
      answer: "It is often possible to recognize if someone is struggling with a mental health condition by observing significant changes in emotions, thoughts, and behaviors, both in oneself and in others. Signs commonly include persistent sadness, mood swings, withdrawal from social activities, sleep or appetite changes, and difficulty coping with daily stress."
    },
    {
      question: "Are mental illnesses common?",
      answer: "Mental illnesses are indeed common in India. According to the National Mental Health Survey (2015-16), about 10.6% of adults in India suffer from mental disorders, with the lifetime prevalence being 13.7%. National studies reveal that approximately 15% of India's adult population experiences mental health issues that require intervention. Common mental disorders include depression, anxiety, bipolar disorder, schizophrenia, and substance use disorders. The burden of mental health problems is significant and increasing, with challenges such as stigma, limited access to care, and shortages of professionals especially in rural areas."
    },
    {
      question: "Can mental illness be treated or cured?",
      answer: "Mental illness generally cannot be completely cured, but it can often be effectively treated and managed to minimize symptoms and improve quality of life. Treatment usually involves a combination of medications, psychotherapy, lifestyle changes, and support, tailored to the individual's specific condition and needs. Many people with mental illness can recover and live long, healthy lives with proper treatment and coping strategies."
    },
    {
      question: "What causes mental illness—biology, environment, or lifestyle?",
      answer: "Mental illness arises from a combination and interaction of biological, environmental, and lifestyle factors. No single cause explains all cases. Instead, genes set a predisposition, which environmental stressors and lifestyle factors may trigger or exacerbate. Understanding this complex causation helps in prevention and treatment strategies."
    },
    {
      question: "Is mental illness the same as stress or sadness?  ",
      answer: " Mental illness is not the same as stress or sadness. Mental illness is a health condition that involves significant changes in a person's thinking, feelings, or behavior and causes distress and difficulty functioning. Stress is a natural response to challenging situations and can be normal or even beneficial in small amounts, whereas mental illness requires medical attention and treatment. Sadness is a normal emotion in response to life events and usually passes over time, while mental illnesses like depression involve persistent and intense symptoms that interfere with daily functioning and often require professional help. Stress can sometimes worsen mental illness, but they are distinct conditions with different implications and treatments."
    },
    {
      question: "Can medication alone treat mental illness, or is therapy also required? ",
      answer: "Medication alone can help manage symptoms of mental illness but often is not enough for thorough treatment. Therapy, or psychotherapy, addresses underlying issues, thought patterns, and coping skills that medication does not. Research indicates the best outcomes usually come from combining medication with therapy, especially for conditions like depression, anxiety, bipolar disorder, and schizophrenia. Thus, therapy is generally recommended alongside medication rather than medication alone for lasting and comprehensive mental health treatment."
    },
    {
      question: "Is mental illness a lifelong condition? ",
      answer: "Mental illness is not always a lifelong condition. Some mental illnesses can be temporary or episodic, while others, especially severe cases, may require long-term management and could be lifelong. With proper treatment, many people improve and return to full functioning, though some may experience relapses or chronic symptoms needing ongoing care."
    },
    {
      question: "How can family and friends support someone with a mental illness? ",
      answer: "Family and friends can support someone with a mental illness by showing care and patience, listening without judgment, encouraging professional help, helping with everyday tasks, educating themselves about the condition, and being empathetic and consistent in their support. Including the person in social plans, reminding them treatment is effective, and respecting their pace and privacy are also important."
    },
    {
      question: "What should I do if I feel I might have a mental illness?",
      answer: " If feeling you might have a mental illness, the best steps are to reach out to a healthcare professional for a proper evaluation, talk openly about your feelings with trusted people, and seek support early to get appropriate care. Prioritize self-care and avoid self-diagnosis."
    },
    {
      question: "Does seeking therapy or psychiatric help mean I’m “weak”?  ",
      answer: "Seeking therapy or psychiatric help does not mean you are 'weak.' It shows strength, self-awareness, and a proactive step toward improving your mental health."
    },
    {
      question: "Can lifestyle changes help improve mental health?  ",
      answer: " Lifestyle changes can indeed help improve mental health. Key beneficial changes include regular physical activity, a nutritious diet, good sleep hygiene, mindfulness practices, strong social connections, and avoiding harmful substances. These changes can prevent mental illness, reduce symptoms, and enhance overall mental well-being by boosting brain function, reducing stress, and promoting resilience."
    },
    {
      question: "What’s the difference between a psychologist and a psychiatrist?  ",
      answer: "The main difference between a psychologist and a psychiatrist is that a psychiatrist is a medical doctor who can prescribe medication and treat mental health conditions using both medication and therapy, while a psychologist focuses on providing talk therapy and cannot prescribe medications. Psychiatrists have medical training and can manage biological aspects of mental health, whereas psychologists have advanced degrees in psychology and focus on behavioral and emotional therapies."
    },
    {
      question: "Is confidentiality maintained in mental health treatment?  ",
      answer: "Confidentiality is generally maintained in mental health treatment to protect the privacy of the individual's diagnosis, treatment, and therapy discussions. Mental health professionals have an ethical and legal duty to keep information private, with some exceptions such as risk of harm to self or others, intentions of committing a crime, or suspected abuse."
    },
    {
      question: "	How can I help reduce the stigma around mental illness? ",
      answer: "To help reduce the stigma around mental illness in short: Talk openly about mental health to normalize it, educate yourself and others with facts, use respectful language, challenge myths and stereotypes, show compassion, and encourage seeking treatment as normal healthcare. Sharing personal stories and speaking out against stigma can also create empathy and understanding."
    },

  ]



  const [isOpen, setisOpen] = useState("null")

  const togglefaqs = (index) => {
    setisOpen(isOpen === index ? null : index)
  }
  return (
    <>
      <div className="max-w-[1456px] mt-2 mx-auto ">
        <div className="bg-gradient-to-r from-[#469B8F] to-transparent pb-8">
          <ServiceSlider
            classname={"flex flex-wrap sm:flex-nowrap px-3"}
            title={"Mentalillness"}
            content={
              "Mental illness is nothing to be ashamed of, but stigma and bias shame us all."
            }
            maincontent={
              "Mental illness is not a weakness, but a part of being human that deserves care and compassion.You are not your illness—healing is possible, and you are never alone."
            }
            buttonname={"Explore Treatment Option "}
            imgs={PsynexaPost2}
          />
        </div>



        <div className="sm:py-16 py-10">
          <div className="text-center border-b-4 max-w-7xl mx-auto">
            <div className="  lg:flex justify-center  mx-auto items-center py-3 gap-6 ">
              <div>
                <img src={PsynexaPost1} className="border-black rounded-2xl" />
              </div>

              <div className="text-center mx-auto sm:text-left ">
                <p className="font-roboto sm:text-3xl text-xl text-center py-5">
                  This is what clinical mental illness can look like....
                </p>
                <div className="  md:flex  px-2 pl-6 justify-center lg:gap-4 ">
                  <Servicelist Symtams={Symtams} />
                  <Servicelist Symtams={symtams1} />
                </div>
                <Button
                  className="text-black hover:text-white mt-5 mx-5 font-roboto text-[18px] content-center bg-[#50b1a4] rounded-full px-4 py-2"
                  btnName={"Get Appointment"}
                  link={"/ContactUs"}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mx-auto py-4">
          <div className="sm:flex justify-around pt-3 items-center">
            <div className=" sm:w-[50%]  w-full ">
              <p className=" flex gap-2 font-semibold uppercase font-roboto text-3xl text-[#469B8F]">
                <FaHandHoldingHeart className="" />

                Guided by Compassion, Grounded in Care

              </p>

              <p className=" mx-auto text-justify text-lg py-3 px-5">
                At Psynexa, we provide personalized mental health care for
                conditions like Depression, Anxiety, Phobias, OCD, and
                trauma-related issues such as PTSD and Acute Stress Reactions.
              </p>
              <p className=" mx-auto text-justify text-lg py-2 px-5">
                We also treat complex disorders including Schizophrenia, Bipolar
                Disorder, and Personality Disorders like borderline and
                narcissistic types, along with Burnout from prolonged stress.
              </p>
              <p className=" mx-auto text-justify text-lg py-2 px-5">
                Our team supports recovery from Eating Disorders, Delirium,
                Dementia, Somatization Disorder, and Headache Disorders like
                Migraines, Tension, and Cluster Headaches.
              </p>
            </div>
            <div className="">
              <img
                src={comit}
                className="w-[400px] h-[400px] p-2 rounded-full "
                alt=""
              />
            </div>
          </div>
        </div>

        <div className="mx-auto bg-[#bde3de] py-10">
          <p className="font-roboto sm:text-xl px-2 capitalize text-base text-center pt-3">
            Mental health problems are treatable with therapies, medications,
            and lifestyle support tailored to each individual.
          </p>
          <p className="font-roboto sm:text-xl px-2 capitalize text-base text-center pt-3">
            Early diagnosis and personalized care can greatly improve well-being
            and quality of life.
          </p>
          <div className="">
            <Tretmentwork />
          </div>
        </div>


        <div className="mx-auto md:pl-[40px] md:pr-[40px] p-2 pt-10">
          <div className="mx-auto">
            <p className="text-2xl font-bold text-center font-roboto">FAQs</p>
          </div>
          <div className="space-y-4 mt-4">
            {Data.map((faq, index) => (
              <div key={index} className="border border-gray-200 w-[100%] mx-auto rounded-lg">
                <button
                  onClick={() => togglefaqs(index)}
                  className="w-full text-left px-4 py-3 flex justify-between items-center focus:outline-none"
                >
                  <span className="font-medium font-roboto">{faq.question}</span>
                  <span>{isOpen === index ? '-' : '+'}</span>
                </button>
                {isOpen === index && (
                  <div className="px-4 py-2 font-roboto text-justify text-gray-600">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Mentalillness;
